import React from "react";
import { useNavigate } from "react-router-dom";

import { Button, Slider } from "../../../../components";

import { useAppDispatch } from "../../../../redux/store";
import {
  resetLastSelectedHall,
  setLastSelectedHall,
} from "../../../../redux/halls/slice";

import styles from "./HallsItem.module.scss";

import {
  removeLastSelectedHallFromStorage,
  setLastSelectedHallToStorage,
} from "../../../../utils/storage/halls";
import { HallsItemPropsType } from "./types";

export const HallsItem: React.FC<HallsItemPropsType> = ({ images, data }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  
  const imagesArray = images && images.length > 0 ? images : (data.images || []);
  const images1 = imagesArray
    .filter((image: { url: string }) => image && image.url)
    .map((image: { url: string }) => image.url);

  React.useEffect(() => {
    dispatch(resetLastSelectedHall());
    removeLastSelectedHallFromStorage();
  }, []);

  const handleChooseHall = () => {
    dispatch(setLastSelectedHall(data));
    setLastSelectedHallToStorage(data);
    navigate("/halls-calendar");
  };

  const handleViewAllPhotos = () => {
    if (imagesArray.length > 0) {
      setLastSelectedHallToStorage({
        title: data.title,
        images: imagesArray
      });
      navigate("/about/hallsFoto/morePhoto");
    }
  };

  return (
    <div className={styles.item}>
      <div className={styles.img}>
        {images1.length > 0 ? (
          <Slider newStyle="slider_small_img" images={images1} />
        ) : (
          <div style={{ padding: '20px', textAlign: 'center', color: '#888' }}>
            Нет изображений
          </div>
        )}
      </div>
      <h3 className={styles.title}>{data.title}</h3>
      <div className={styles.buttons}>
        <Button newStyles={styles.button} onClickFunc={handleChooseHall}>
          Арендовать
        </Button>
        <Button 
          newStyles={styles.buttonAllPhotos} 
          onClickFunc={handleViewAllPhotos}
          disabled={images1.length === 0}
        >
          Все фото
        </Button>
      </div>
    </div>
  );
};
